import { RouterProvider } from 'react-router-dom';

import { AppProviders } from '@/app/providers/AppProviders';
import { router } from '@/app/router/routes';

/**
 * Application root: providers wrapped around the router.
 *
 * Kept separate from `main.tsx` so tests can mount the app without touching
 * `createRoot` or the real DOM entry point.
 */
export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
